import React from 'react';

import ChatItem from './ChatItem';

const ChatList = ({ chats, selectedChatId, setSelectedChatId, highlightedChatId }) => {
  return (
    <div className='chat-list'>
      <span style={{ color: '#FFFDFE' }}>Чати</span>

      {chats.map((chat, index) => (
        <ChatItem
          index={index}
          key={chat.id}
          chat={chat}
          isSelected={selectedChatId === chat.id}
          onClick={() => setSelectedChatId(chat.id)}
          isHighlighted={highlightedChatId === chat.id}
        />
      ))}
    </div>
  );
};

export default ChatList;
